import { FC, ReactNode, useEffect, useMemo, useState } from 'react';
import { authService } from '../../services';
import { AuthContext } from './AuthContext';

export interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider: FC<AuthProviderProps> = (props) => {
  const { children } = props;

  const [initialized, setInitialized] = useState(false);
  const [authorized, setAuthorized] = useState(false);
  const [authToken, setAuthToken] = useState<string | null>(null);

  const contextValue = useMemo(() => {
    return {
      initialized,
      authorized,
      setAuthData: authService.setAuthData,
      logout: authService.logout,
      authToken,
    };
  }, [initialized, authorized, authToken]);

  useEffect(() => {
    setAuthorized(authService.authorized);
    setInitialized(authService.initialized);
    return authService.on('change', (data) => {
      setAuthorized(data.authorized);
      setInitialized(data.initialized);
    });
  }, []);

  useEffect(() => {
    if (initialized && authorized) {
      const initialize = async () => {
        const token = await authService.getValidAccessToken();
        setAuthToken(token);
      };

      initialize();
    }

    const refreshInterval = setInterval(async () => {
      if (!initialized || !authorized) {
        return;
      }
      try {
        const token = await authService.getValidAccessToken();
        setAuthToken(token);
      } catch (err) {
        console.error('Token refresh failed', err);
        // do nothing the auth service will handle it
      }
    }, 270000); // 4.5 minutes because the token is valid for 5 minutes

    return () => clearInterval(refreshInterval);
  }, [initialized, authorized]);

  return (
    <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>
  );
};
